import React from 'react';
import {Routes, Route} from 'react-router-dom';
import TributeCreator from './TributeCreator';
import ReadTribute from './ReadTribute';
import LandingPage from './LandingPage';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import Footer from './Footer';
import QuizPage from './QuizPage';
import QuizUpload from './QuizUpload';
import './App.css';

function HomePage() {
    return (
        <LandingPage>
            <TributeCreator/>
        </LandingPage>
    );
}

function ReadTributePage() {
    return (
        <main>
            <ReadTribute/>
        </main>
    );
}

function PrivacyPolicyPage() {
    return (
        <main>
            <PrivacyPolicy/>
        </main>
    );
}

function TermsOfServicePage() {
    return (
        <main>
            <TermsOfService/>
        </main>
    );
}


function App() {
    return (
        <div className='App'>
            <Routes>
                <Route path='/' element={<HomePage/>}/>
                <Route path='/upload-quiz' element={<QuizUpload/>}/>
                <Route path='/quiz/:id' element={<QuizPage/>}/>
                <Route path='/read/:id' element={<ReadTributePage/>}/>
                <Route path='/polityka-prywatnosci' element={<PrivacyPolicyPage/>}/>
                <Route path='/regulamin' element={<TermsOfServicePage/>}/>
            </Routes>
            <Footer/>
        </div>
    );
}

export default App;
